<template>
  <UiModal :open="status_pad_transfer" @close="status_pad_transfer = false">
    <div v-if="meta_item" class="px-5 pb-5">
      <h3 class="pt-4">Transfer</h3>
      <div class="tac" style="">

        <!-- <img :src="item.image" style="height: 120px;"> -->
        <div class="pic-holder">
          <CpNftCoverImg 
            style="height: 160px;"
            :src="item.image"
          />
        </div>
        
        <div class="b mt-1">
          {{item.name}}
        </div>
      </div>
      <div class="mb-3">
        <label>Amount</label>
        <input v-model="input_transfer_amount" type="number" step="1" min="1" :max="meta_item.num_my" class="form-control" placeholder="Amount">
      </div>
      <div class="mb-3">
        <label>To Address</label>
        <input v-model="input_transfer_address" type="text" class="form-control" placeholder="To Address">
      </div>
      <div class="mt-5 tac">

        <span v-if="status_btn_loading" class="ui-loading-icon size-sm">
          <!-- loading -->
        </span>
        <button v-else @click="submitTransfer()" class="btn btn-primary gold" style="min-width: 150px;">
          Transfer
        </button>
      </div>
    </div>
  </UiModal>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: '',
  components: {},
  props: [
    'cfg_status_poppad',
    'meta_item',
    'item',
  ],
  data() {
    return {
      status_pad_transfer: false,

      status_btn_loading: false,

      input_transfer_amount: '',
      input_transfer_address: '',
    }
  },
  computed: {},
  watch: {
    cfg_status_poppad(val){
      this.status_pad_transfer = val
    },
    status_pad_transfer(val){
      if(val){
        this.run()
      }else{
        this.$parent.btnToggleTransfer(false)
      }
    },
  },
  methods: {
    ...mapActions([
      'nftBalance',
      'nftTransfer',
    ]),

    async submitTransfer(){
      let v = this

      let form = {
        address: v.$store.state.web3.account,
        NTFS_TOKEN_ADDRESS: v.meta_item.nft_address,
        NFT_ID: v.meta_item.nft_id,
        type: v.meta_item.type,
        to_address: v.input_transfer_address,
        num: v.input_transfer_amount,
        callback: function(){
          setTimeout(() => {            
            v.status_btn_loading = false
  
            v.$toasted.show(v.lg('',{
              en: 'Transfered',
              zh: 'Transfer 成功',
            }))
            v.status_pad_transfer = false
  
            if(v.$parent.run){
              v.$parent.run()
            }
          }, 3000);
        },
        callbackOnErr: function(){
          v.status_btn_loading = false
        },
      }

      v.status_btn_loading = true
      await v.nftTransfer(form)
    },

    async getBalanceNum(){
      let v = this

      let form = {
        address: v.$store.state.web3.account,
        NTFS_TOKEN_ADDRESS: v.meta_item.nft_address,
        NFT_ID: v.meta_item.nft_id,
        type: v.meta_item.type
      }

      let num = await v.nftBalance(form)
      v.input_transfer_amount = num
    },

    run(){
      this.input_transfer_amount = ''
      this.getBalanceNum()
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>